import './App.css';

import { useState } from 'react';

// import Navbar from './components/Navbar';
// import Footer from './components/Footer';
import Homepage from './pages/Homepage';
import Farm from './pages/Farm';
import Token from './pages/Token';
import Contact from './pages/Contact';
import { Route, Routes } from 'react-router-dom';
import Defi from './pages/Defi';


import WalletConnectProvider from '@walletconnect/web3-provider';
import CoinbaseWalletSDK from '@coinbase/wallet-sdk';
import Web3 from "web3"
import Web3Modal from 'web3modal';

import { nftABI, nftAddress } from "./eth/mumbai-testnet/nft-contract.json"



function App() {
  const [isConnect, setIsConnect] = useState([])
  const [myWeb3, setMyWeb3] = useState([])
  const [nftContract, setNftContract] = useState([])

  const ConnectWallet = async () => {
    try {
      const provider = await web3Modal.connect();
      const web3 = new Web3(provider);
      const address = await web3.eth.getAccounts();
      const network = await web3.eth.net.getId();
      const myNftContract = await new web3.eth.Contract(nftABI, nftAddress)

      console.log(address);
      setMyWeb3(web3);
      setIsConnect(address[0]);
      setNftContract(myNftContract)

    } catch (err) {
      console.log("err.message");
      console.log(err);
    }
  }

  const disconnectWallet = () => {
    setIsConnect([]);
    setMyWeb3([]);
  }

  const providerOptions = {
    walletconnect: {
      package: WalletConnectProvider, // required
      options: {
        infuraId: "104e5586c1fe4cde93558f3f58048ced", // required
        chainId: 1
      },
    },
    coinbasewallet: {
      package: CoinbaseWalletSDK, // Required
      options: {
        appName: "DuckDuckGooseGame", // Required
        infuraId: "104e5586c1fe4cde93558f3f58048ced", // Required
        rpc: "https://rpc.ankr.com/polygon_mumbai/", // Optional if `infuraId` is provided; otherwise it's required
        chainId: 1, // Optional. It defaults to 1 if not provided
        darkMode: true // Optional. Use dark theme, defaults to false
      }
    }
  };

  const web3Modal = new Web3Modal({
    cacheProvider: false,
    providerOptions, // required
  });



  return (
    <>
      <Routes>
        <Route
          exact
          path="/"
          element={
            <Homepage
              ConnectWalletFunc={ConnectWallet}
              state={isConnect}
              setState={setIsConnect}
              disconnectWallet={disconnectWallet}
            />
          }
        />
        <Route
          exact
          path="/farm"
          element={
            <Farm
              ConnectWalletFunc={ConnectWallet}
              state={isConnect}
              setState={setIsConnect}
              disconnectWallet={disconnectWallet}
              nftContract={nftContract}
              myWeb3={myWeb3}
            />
          }
        />
        <Route
          exact
          path="/token"
          element={
            <Token
              ConnectWalletFunc={ConnectWallet}
              state={isConnect}
              setState={setIsConnect}
              disconnectWallet={disconnectWallet}
            />
          }
        />
        <Route
          exact
          path="/defi"
          element={
            <Defi
              ConnectWalletFunc={ConnectWallet}
              state={isConnect}
              setState={setIsConnect}
              disconnectWallet={disconnectWallet}
            />
          }
        />
        <Route
          exact
          path="/contact"
          element={
            <Contact
              ConnectWalletFunc={ConnectWallet}
              state={isConnect}
              setState={setIsConnect}
              disconnectWallet={disconnectWallet}
            />
          }
        />
      </Routes>
    </>
  );
}


export default App;